import { ISpecializedCombo, useCombo } from '@hooks/useCombo';
import { MenuItem } from '@material-ui/core';
import { useCaixaService } from '@services/CaixaService';
import React from 'react';

export interface ICaixa {
    caixaId: number
    usuarioId: number
    
    nome: string
    ativo: string

    usuarioNome: string
}

export type IComboCaixa = ISpecializedCombo<ICaixa>;

export function useCaixaCombo (initialValue?: number) : IComboCaixa {
    const combo = useCombo<ICaixa>({
        value: initialValue
    });

    const caixaService = useCaixaService();

    const createOptions = React.useCallback(() => {
        return combo.set.map((caixa, index) => {
            return <MenuItem key={index} value={caixa.caixaId}>{ caixa.usuarioNome }</MenuItem>
        });
    }, [combo.set]);

    const loadOptions = React.useCallback(() => {
        combo.load(caixaService.listarAtivos)
    }, [combo, caixaService.listarAtivos]);

    return React.useMemo(() => ({
        ...combo, createOptions, loadOptions
    }), [combo, createOptions, loadOptions]);
}